<template>
  <div>
    <el-checkbox-group v-model="checkedDics" @change="handleCheckedDicsChange">
      <el-checkbox v-for="dic in dicData" :label="dic.value" :key="dic.value" :disabled="disabled">{{dic.label}}</el-checkbox>
    </el-checkbox-group>
  </div>
</template>

<script>
import mixinRemoteDic from './mixins/remoteDic'
export default {
  props: ['column', 'scope'],
  mixins: [mixinRemoteDic],
  data() {
    const {
      dicData,
      disabled,
      prop
    } = this.column
    return {
      disabled: !!disabled,
      dicData,
      checkedDics: this.scope.row[prop] || []
    }
  },
  watch: {
    // checkedDics(v) {
    //   this.$emit('on-edit', v, this.column.prop, this.scope.$index)
    // },
    scope({ row }) {
      this.checkedDics = row[this.column.prop]
    }
  },
  methods: {
    handleCheckedDicsChange(val) {
      // console.log(val)
      this.$emit('on-edit', val, this.column.prop, this.scope.$index)
    }
  }
}
</script>

<style lang="scss">
.el-checkbox {
  margin-right: 10px;
}
</style>
